import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function FAQ() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: "¿Cómo puedo descargar e instalar Facturas Simples?",
      answer: "Para instalar Facturas Simples: 1. Ve a tu App Store, 2. Busca 'Facturas Simples', 3. Selecciona la aplicación de la lista, 4. Haz clic en 'Instalar' y luego 'Abrir'. También puedes usar el link directo: https://apps.apple.com/us/app/facturas-simples/id6741133517?ppid=518f04bc-8fa7-4d62-a012-30441aee8baa"
    },
    {
      question: "¿Cómo me registro en la aplicación por primera vez?",
      answer: "Para registrarte: 1. Abre la aplicación y haz clic en 'Ingresar Con Cuenta Apple', 2. Completa los campos con tu información fiscal: nombre de empresa, NIT, teléfono, dirección y correo electrónico, 3. Selecciona tu rubro o actividad económica."
    },
    {
      question: "¿Qué necesito para validar mi cuenta?",
      answer: "Para validar tu cuenta necesitas: 1. Subir tu certificado para firma de documentos tributarios, 2. Si no estás registrado en Hacienda, haz clic en 'Hacienda facturación Electrónica' para registrarte en https://admin.factura.gob.sv/login, 3. Una vez tengas el certificado, selecciónalo desde tu carpeta de archivos, 4. Ingresa y confirma tu contraseña del certificado."
    },
    {
      question: "¿Cómo me registro como emisor de DTE en Hacienda?",
      answer: "Para registrarte como emisor de DTE: 1. Ingresa a https://admin.factura.gob.sv/login, 2. Si es primera vez, selecciona 'Solicitud de Ingreso', 3. Completa tus datos de NIT/DUI y contraseña, 4. Una vez dentro, ve a 'Solicitar Autorización' del menú principal, 5. Completa las pruebas mínimas de los documentos tributarios electrónicos y eventos."
    },
    {
      question: "¿Qué tipos de documentos puedo autorizar en el sistema DTE?",
      answer: "Puedes autorizar varios tipos de documentos: Factura, Comprobante de Crédito Fiscal, Nota de Remisión, Nota de Crédito, Documento Contable de Liquidación, Comprobante de Débito, Comprobante de Retención, Factura de Sujeto Excluido, Documento Contable de Exportación y Comprobante de Donación. También debes completar las pruebas de eventos de invalidación y contingencia."
    },
    {
      question: "¿Cómo agrego un nuevo cliente?",
      answer: "Para agregar un cliente: 1. Ve a la pestaña 'Clientes' en la parte inferior, 2. Haz clic en el símbolo '+' en la esquina superior derecha, 3. Completa los datos del nuevo cliente, 4. En 'Configuración de facturación' agrega los datos necesarios para emisión de créditos fiscales."
    },
    {
      question: "¿Cómo creo una nueva factura?",
      answer: "Para crear una factura: 1. Haz clic en 'Nueva Factura' en la esquina superior derecha, 2. Completa los campos: nombre del cliente, fecha y tipo de documento (Factura o Crédito Fiscal), 3. Usa el buscador para productos inventariados o agrega nuevos productos con el símbolo '+', 4. Ingresa nombre del producto, costo con y sin IVA, 5. Haz clic en 'Crear Factura'."
    },
    {
      question: "¿Cómo puedo enviar una factura por email?",
      answer: "Para enviar una factura: 1. Ve a la factura creada, 2. En la esquina superior derecha verás opciones de gestión, 3. Selecciona 'enviar al correo' para enviarla por email, o puedes verificarla en formato PDF antes de enviar. También puedes validar la factura emitida desde estas opciones."
    },
    {
      question: "¿Cómo anulo una factura?",
      answer: "Para anular una factura: 1. Ve a 'Anular factura', 2. Completa los campos requeridos para anular documentos, 3. Genera la nota de crédito correspondiente, 4. Puedes anular total o parcialmente la factura, 5. Haz clic en 'sincronizar' en la parte inferior de la pantalla hasta que el estado aparezca como 'cancelado'."
    },
    {
      question: "¿Cómo agrego productos a mi catálogo?",
      answer: "Para agregar productos: 1. Haz clic en 'PRODUCTOS' en la esquina inferior derecha, 2. Visualiza todos los productos inventariados, 3. Para agregar nuevos productos, completa los campos correspondientes: nombre, descripción del producto y costo."
    },
    {
      question: "¿Cuáles son los planes de precios disponibles?",
      answer: "Tenemos 3 planes de suscripción: 1. Lite (Gratis) — todos los tipos de DTE soportados, 1 empresa, módulo de Compras, con anuncios de video antes de sincronizar. 2. Sin Publicidad ($5.99/mes) — todo lo de Lite + hasta 2 empresas + sin anuncios. 3. Pro ($9.99/mes) — todo lo anterior + empresas ilimitadas + sincronización en la nube (Azure) + envío de correos + exportación de datos. Todos incluyen soporte técnico y actualizaciones gratuitas."
    },
    {
      question: "¿Cómo cambio el logo de mi empresa en las facturas?",
      answer: "Para cambiar el logo: 1. Ve a 'Perfil' > 'Configuración', 2. Busca la opción 'Edita logo de facturas', 3. Haz clic y adjunta la imagen del logo de tu empresa, 4. Este logo será visualizado en la esquina superior derecha de tus facturas."
    },
    {
      question: "¿Qué es el proceso de autorización a producción?",
      answer: "El proceso de autorización a producción te ayuda a preparar y enviar la solicitud de credenciales productivas al Ministerio de Hacienda. Ve a 'Configuración' > 'Acceso a Producción' o al detalle de empresa, selecciona los tipos de DTE que deseas habilitar y completa los datos solicitados antes de enviar la solicitud."
    },
    {
      question: "¿Cómo actualizo mi certificado?",
      answer: "Para actualizar tu certificado: 1. Ve a 'Perfil' > 'Configuración', 2. Selecciona 'Actualización de Certificado', 3. Si también necesitas cambiar la contraseña, usa 'Actualización de Contraseña'. Esto es útil cuando has realizado alguna modificación en tu certificado tributario."
    },
    {
      question: "¿Cómo busco una factura específica?",
      answer: "Para buscar facturas: 1. Ve a la pestaña 'Facturas' en la esquina inferior derecha, 2. Usa el buscador en la esquina superior izquierda, 3. Coloca las iniciales o nombre del cliente/empresa, 4. También puedes verificar por número correlativo, fecha de emisión o estado de la factura. Al hacer clic en la pestaña podrás ingresar a la factura y verificar la información registrada."
    },
    {
      question: "¿Puedo tener múltiples empresas en una cuenta?",
      answer: "Sí, puedes tener múltiples empresas. En 'Configuración' encontrarás la opción 'Establecer como Predeterminada' donde puedes elegir o cambiar la empresa que estará facturando actualmente. También puedes usar 'Editar Datos de Empresa' para ingresar la información de una nueva empresa con sus datos de facturación y datos generales."
    },
    {
      question: "¿Qué pasos debo seguir para completar la solicitud de autorización DTE en Hacienda?",
      answer: "Para completar la solicitud DTE: 1. Selecciona los tipos de DTE que han cumplido las pruebas mínimas, 2. Introduce tu correo y teléfono para notificaciones, 3. Confirma las autorizaciones para mostrar tu empresa en la web de Hacienda, 4. Verifica los datos de tu solicitud, 5. Confirma tu correo electrónico mediante el enlace de autenticación, 6. Recibirás la notificación de autorización por correo con una copia para descargar."
    },
    {
      question: "¿Qué información debo proporcionar para la notificación electrónica en el proceso DTE?",
      answer: "Debes proporcionar: 1. Tu nombre como contribuyente, representante legal o apoderado registrado en el RUC, 2. Correo electrónico personal de quien presenta la solicitud, 3. Teléfono personal de quien presenta la solicitud. El sistema indicará automáticamente si es tu primera solicitud o una ampliación de una previa."
    },
    {
      question: "¿Dónde puedo encontrar más información sobre el proceso de autorización DTE?",
      answer: "El proceso de autorización DTE está detallado en el Manual de Solicitud en Línea para ser autorizado como Emisor de DTE del Ministerio de Hacienda. Este manual explica el proceso conforme a los artículos 73 y 74 de la Ley de Procedimientos Administrativos y está diseñado para orientarte en todo el proceso de autorización mediante el sitio web oficial."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-100 to-white">
      {/* Navigation */}
      <nav className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="font-bold text-2xl text-blue-600">Facturas Simples</Link>
          <div className="hidden md:flex space-x-6">
            <Link to="/" className="hover:text-blue-600">Volver al Inicio</Link>
          </div>
        </div>
      </nav>
      
      {/* Header */}
      <header className="container mx-auto px-6 py-16 md:py-24">
        {/* Back Button */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Volver a la página principal
          </Link>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-6">Preguntas Frecuentes</h1>
        <p className="text-center text-gray-600 max-w-2xl mx-auto">
          Encuentra respuestas a las preguntas más comunes sobre Facturas Simples. Si no encuentras lo que buscas, contáctanos.
        </p>
      </header>
      
      {/* FAQ Section */}
      <section className="container mx-auto px-6 pb-24">
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4 bg-white rounded-lg shadow-md overflow-hidden">
              <button
                className="w-full text-left p-6 focus:outline-none hover:bg-gray-50 flex justify-between items-center"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-lg font-semibold text-gray-800 pr-8">{faq.question}</h3>
                <svg
                  className={`w-5 h-5 text-blue-600 transform transition-transform ${
                    openFAQ === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-6">
                  <div className="border-t pt-4">
                    <p className="text-gray-600 leading-relaxed whitespace-pre-line">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Contact CTA */}
        <div className="max-w-4xl mx-auto mt-16 text-center bg-blue-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">¿No encontraste lo que buscabas?</h2>
          <p className="text-gray-600 mb-6">
            Nuestro equipo de soporte está aquí para ayudarte con cualquier pregunta adicional.
          </p>
          <Link
            to="/cotizacion"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold inline-block"
          >
            Solicitar cotización
          </Link>
        </div>
      </section>
    </div>
  );
}

export default FAQ;
